<template>
  <div>
    <Menu/>
    <div class="container-fluid">
      <slot/>
      <Footer/>
    </div>
  </div>
</template>
<script>
import Menu from './Menu.vue';
import Footer from './Footer.vue';
import Content from './Content.vue';

export default {
  name: 'Content',
  components: {
    Menu,
    Footer,
    Content,
  },
  data() {
    return {
    }
  }
};
</script>

<style type="text/css">
.container {
	margin-top: 10px;
	color: #7e7e7e;
	height: -webkit-fill-available;
	margin-right: auto;
	margin-left: auto;
	padding-left: 45px;
	padding-right: 15px;
	height: auto!important;
}
.md-title{
	color: #6d747c;
	font-weight: 400!important;
	font-family:Lato, sans-serif;
	font-size:12px;
}
.md-table-cell {
	height: 40px;
	transition: .3s cubic-bezier(.4,0,.2,1);
	font-size: 12px;
	font-family: Lato,sans-serif;
	color: #7e7e7e;
	padding-left:  5px;
}
</style>



// WEBPACK FOOTER //
// src/accountant/public/Content.vue